export function customSelectInit(containers) {
    let elements = [];
    /* Look for any elements with the selector: */
    let containers_length = containers.length;
    for (let i = 0; i < containers_length; i++) {
        elements.push( initSelectElement(containers[i]) );
    }

    return elements;
}

function initSelectElement(container) {
    let select_element = container.getElementsByTagName("select")[0];
    /* For each element, create a new DIV that will act as the selected item: */
    let div_select = document.createElement("div");
    div_select.setAttribute("class", "select-selected");
    div_select.innerHTML = select_element.options[select_element.selectedIndex].innerHTML;
    container.appendChild(div_select);
    /* For each element, create a new DIV that will contain the option list: */
    let div_option_list = document.createElement("div");
    div_option_list.setAttribute("class", "select-items select-hide");

    process_options(select_element, div_option_list)

    container.appendChild(div_option_list);

    div_select.addEventListener("click", function(e) {
        exitingSelect(this, e);
    });

    return container;
}

function process_options(select, option_list) {
    let select_length = select.length;
    for (let i = 1; i < select_length; i++) {
        /* For each option in the original select element,
        create a new DIV that will act as an option item: */
        let option_item = document.createElement("div");
        option_item.innerHTML = select.options[i].innerHTML;
        option_item.setAttribute("data-value",  select.options[i].value );
        option_item.addEventListener("click", function(e) {
            onClickOption(this);
        });

        option_list.appendChild(option_item);
    }
}
function onClickOption(that) {
    /* When an item is clicked, update the original select box, and the selected item: */
    let original_select = that.parentNode.parentNode.getElementsByTagName("select")[0];
    let original_select_length = original_select.length;
    let option_previous_sibling = that.parentNode.previousSibling;
    for (let i = 0; i < original_select_length; i++) {
        if (original_select.options[i].innerHTML === that.innerHTML) {
            original_select.selectedIndex = i;
            original_select.dispatchEvent( new Event('change') );

            option_previous_sibling.innerHTML = that.innerHTML;
            let same_as_selected = that.parentNode.getElementsByClassName("same-as-selected");
            let same_as_selected_length = same_as_selected.length;
            for (let k = 0; k < same_as_selected_length; k++) {
                same_as_selected[k].removeAttribute("class");
            }
            that.setAttribute("class", "same-as-selected");
            break;
        }
    }

    option_previous_sibling.click();
}

function exitingSelect(that, event=null) {
    /* When the select box is clicked, close any other select boxes,
        and open/close the current select box: */
    if ( event ) {
        event.stopPropagation();
    }

    closeAllSelect(that);
    that.nextSibling.classList.toggle("select-hide");
    that.classList.toggle("select-arrow-active");
}

export function selectOption(that, value) {
    let custom_select_option = that.querySelector(`[data-value='${value}']`);
    if ( custom_select_option ) {
        custom_select_option.click();
        let selected_option = that.querySelector( '.select-selected' );
        if ( selected_option ) {
            exitingSelect( selected_option );
        }
    }
}

function closeAllSelect(elmnt) {
    /* A function that will close all select boxes in the document,
    except the current select box: */
    var x, y, i, xl, yl, arrNo = [];
    x = document.getElementsByClassName("select-items");
    y = document.getElementsByClassName("select-selected");
    xl = x.length;
    yl = y.length;
    for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
            arrNo.push(i)
        } else {
            y[i].classList.remove("select-arrow-active");
        }
    }
    for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
            x[i].classList.add("select-hide");
        }
    }
}

/* If the user clicks anywhere outside the select box,
   then close all select boxes: */
document.addEventListener("click", closeAllSelect);